<!--
 * @Descripttion:图表公共属性配置
 * @Author: zenghua.wang
 * @Date: 2021-06-03 14:48:03
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-25 10:13:41
-->
<template>
  <div>
    <!-- 标题设置 -->
    <el-collapse-item title="标题设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.titleShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="标题">
        <el-input
          v-model="data.option.titleText"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.titleTextColor"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.titleTextFontSize"
          placeholder="请输入"
        >
        </el-input-number>
      </el-form-item>

      <el-form-item label="字体位置">
        <el-select
          v-model="data.option.titleLeft"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in alignList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="副标题">
        <el-input
          v-model="data.option.titleSubtext"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.titleSubtextColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.titleSubtextFontSize"
          placeholder="请输入"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- X轴设置 -->
    <el-collapse-item
      title="X轴设置"
      v-if="xyList.includes(data.option.type)"
    >
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.xAxisShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="显示轴线">
        <el-switch
          v-model="data.option.xAxisLine"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="显示刻度">
        <el-switch
          v-model="data.option.xAxisTickShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="显示网格线">
        <el-switch
          v-model="data.option.xAxisSplitLineShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="X轴名称">
        <el-input v-model="data.option.xAxisName" />
      </el-form-item>

      <el-form-item label="文字角度">
        <el-input-number
          v-model="data.option.xAxisLabelRotate"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.xAxisNameFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.xAxisNameColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- Y轴设置 -->
    <el-collapse-item
      title="Y轴设置"
      v-if="xyList.includes(data.option.type)"
    >
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.yAxisShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="显示轴线">
        <el-switch
          v-model="data.option.yAxisLine"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="显示刻度">
        <el-switch
          v-model="data.option.yAxisTickShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="显示网格线">
        <el-switch
          v-model="data.option.yAxisSplitLineShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <!-- <el-form-item label="反转">
        <el-switch
          v-model="data.option.yAxisInverse"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item> -->

      <el-form-item label="Y轴名称">
        <el-input v-model="data.option.yAxisName" />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.yAxisNameFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.yAxisNameColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 坐标轴边距设置 -->
    <el-collapse-item
      title="坐标轴边距设置"
      v-if="xyList.includes(data.option.type)"
    >
      <el-form-item label="左边距(px)">
        <el-slider
          v-model="data.option.gridLeft"
          max="200"
        />
      </el-form-item>

      <el-form-item label="顶边距(px)">
        <el-slider
          v-model="data.option.gridTop"
          max="200"
        />
      </el-form-item>

      <el-form-item label="右边距(px)">
        <el-slider
          v-model="data.option.gridRight"
          max="200"
        />
      </el-form-item>

      <el-form-item label="底边距(px)">
        <el-slider
          v-model="data.option.gridBottom"
          max="200"
        />
      </el-form-item>

      <el-form-item label="轴线颜色">
        <el-color-picker
          v-model="data.option.lineColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="轴线文字大小">
        <el-input-number
          v-model="data.option.lineFontSize"
          placeholder="请输入"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 数值设置 -->
    <el-collapse-item
      title="数值设置"
      v-if="commomList.includes(data.option.type)"
    >
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.labelShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="单位">
        <el-input
          v-model="data.option.unit"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.labelShowFontSize"
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.labelShowColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.labelShowFontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <!-- 提示语设置 -->
    <el-collapse-item title="提示语设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.tipShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="formatter">
        <el-button
          size="small"
          type="primary"
          @click="setFormatter(data.option.tipFormatter, 'tips')"
        >设置</el-button>
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number v-model="data.option.tipFontSize" />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.tipColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 图例设置 -->
    <el-collapse-item
      title="图例设置"
      v-if="commomList.includes(data.option.type)"
    >
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.legendShow"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="位置">
        <el-select
          v-model="data.option.legendLeft"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in alignList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="布局朝向">
        <el-select
          v-model="data.option.legendOrient"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in orientList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="顶边距(%)">
        <el-slider
          v-model="data.option.legendTop"
          max="100"
        />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.legendColor"
          :predefine="predefineColors"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.legendFontSize"
          placeholder="请输入"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 颜色设置 -->
    <echart-color
      :data="data"
      :linearList="linearList"
      v-if="data.option.type!=='map'"
    />

    <!-- 链接 -->
    <config-link :data="data" />

    <!-- formatter -->
    <echart-formatter
      :show.sync="formatter.show"
      :formatter="formatter.code"
      :placeholder="placeholder"
      @change="updateFormatter"
    />

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </div>
</template>

<script>
import {
  predefineColors,
  component,
  echartConfig,
  theme
} from '@/dragComponents/model/default.js'

import configLink from '@/dragComponents/config/common/link.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import echartColor from '@/dragComponents/config/common/color.vue'
import echartFormatter from '@/dragComponents/config/common/formatter.vue'

export default {
  name: 'echart-common',
  components: {
    configLink,
    configAuth,
    echartColor,
    echartFormatter
  },
  inject: ['main', 'category'],
  props: ['data'],
  data() {
    return {
      theme: theme,
      weightList: component.weightType,
      orientList: echartConfig.orients,
      alignList: component.alignType,
      predefineColors: predefineColors,
      formatter: {
        show: false,
        code: '',
        type: 'tips'
      },
      xyList: ['bar', 'line'],
      commomList: ['bar', 'line', 'pie', 'funnel', 'radar'],
      linearList: ['bar', 'line', 'pie', 'funnel', 'gauge'],
      placeholder: `formatter函数书写提示  
函数一          
/*
params: Object {name,value} 如柱状图经过的当前柱体对象
list: Array apis接口请求返回的数据
*/      
function formatter(params, list) {
  let tips = ''
  // 这里是你自定义的处理逻辑
  return tips
}
适用图表：柱状图、折线图、饼图、漏斗图、雷达图

函数二
/*
params: Object {name,value} 其中name=null
list: Array apis接口请求返回的数据
*/      
function formatter(params, list) {
  if (params.value === 87.5) {
    return '优'
  } else if (params.value === 62.5) {
    return '良'
  } else if (params.value === 37.5) {
    return '中'
  } else if (params.value === 12.5) {
    return '差'
  }
  return ''
}
适用图表：仪表盘`
    }
  },
  methods: {
    setFormatter(val, type) {
      this.formatter.code = val
      this.formatter.type = type
      this.formatter.show = true
    },
    updateFormatter(val) {
      let self = this
      switch (self.formatter.type) {
        case 'tips':
          self.data.option.tipFormatter = val
          break
        default:
      }
    }
  }
}
</script>
